import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/api/queryKeys";
import { toast } from "@/lib/toast";
import { registerByokKey } from "../api";
import type { ByokKey, RegisterKeyInput } from "../types";

export function useAddByokKey() {
  const qc = useQueryClient();
  return useMutation<ByokKey, unknown, RegisterKeyInput>({
    mutationFn: registerByokKey,
    onSuccess: () => {
      toast.success("Chave registrada");
      qc.invalidateQueries({ queryKey: queryKeys.byok.all });
    },
    onError: () => {
      toast.error("Não foi possível registrar a chave");
    },
  });
}
